module.exports = __webpack_public_path__ + "img/depsec.fcf85583.png";